import { AdvancedVideoPlayer } from '@features/advancedVideoPlayer';
import { Box } from '@radix-ui/themes';

export const ClipPlayer = () => {
    return (
        <Box flexGrow={'1'} height={'100%'}>
            <AdvancedVideoPlayer
                engine={'limecraft'}
                // engine={'videojs'}
            />
        </Box>
    );
};
